import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';

import messages from './RodoPolicyView.intl';

import ContentStore from 'stores/Content.store';

import { Container, Title } from 'common/components/Layout/Layout';
import AccordionList from '../../common/components/AccordionList/AccordionList';
import FullWidthBackground from 'common/components/Placeholder/components/FullWidthBackground/FullWidthBackground';
import ImageGreyBackground from 'common/components/ImageGreyBackground/ImageGreyBackground';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';
import Link from '../../common/components/Link/Link';
import Placeholder from 'common/components/Placeholder/Placeholder';

import styles from './RodoPolicy.module.scss';

@injectIntl
@observer
export default class RodoPolicyView extends Component {
  render() {
    const content = ContentStore.content;

    return (
      <div>
        {ContentStore.isLoaded && <InjectMetaTags {...content.rodoPolicySEO} />}
        <Container>
          <Title title={this.props.intl.formatMessage(messages.heading)} />
        </Container>
        <Placeholder component={<FullWidthBackground />} ready={!!content}>
          {content && (
            <ImageGreyBackground
              className={styles.BoldHeading}
              source={content.rodoPolicyImage}
              alternative="hello"
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: content.rodoPolicyText
                }}
              />
            </ImageGreyBackground>
          )}
        </Placeholder>
        {content && (
          <Container>
            <AccordionList accordionList={content.rodoPolicyAccordionList} />
            {content.rodoPolicyLinks.map(link => (
              <Link
                key={link.id}
                isBlank={link.isBlank === 'true' ? true : false}
                title={link.title}
                url={link.url}
              />
            ))}
          </Container>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/RodoPolicy/RodoPolicyView.js